
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { DEFINITION_OPSUB } from '../../common/common/iskn/opsub';
import { DEFINITION_PAR } from '../../common/common/iskn/par';
import { DEFINITION_TEL } from '../../common/common/iskn/tel';

import IfComp from '../common/IfComp';

import OpsubFilter from './OpsubFilter';
import ParcelFilter from './ParcelFilter';
import TelFilter from './TelFilter';

const IsknObjectFilter = ({objectType}) => {
    return (
        <Stack>
            <IfComp cond={objectType === DEFINITION_OPSUB.objectType} >
                <OpsubFilter
                />
            </IfComp>
            <IfComp cond={objectType === DEFINITION_PAR.objectType} >
                <ParcelFilter
                />
            </IfComp>
            <IfComp cond={objectType === DEFINITION_TEL.objectType} >
                <TelFilter
                />
            </IfComp>
        </Stack>
    );
}

export default IsknObjectFilter;
